import FormGroup from "../form/FormGroup";
import Reaptcha from "reaptcha";
import React from "react";

export default function GoogleRecaptchaRenderer({onChange, recaptcha_site_key}){
    const onVerified = (response) => {
        if (onChange) {
            onChange({
                type:'recaptcha',
                value: response,
            })
        }
    }
    return (<FormGroup>
            <Reaptcha sitekey={recaptcha_site_key} onVerify={onVerified}/>
        </FormGroup>
    );
}
